module.exports = __webpack_public_path__ + "img/form2.48b5b8bf.png";